export const claimTypeDropdownConfiguration = {
    id: 'claimDataTypeName',
    label: 'Claim Type',
    searchOptions: ['option1', 'option2'],
    isSearch: false,
    hasClear: false,
    checkBoxes: [
        { label: 'Permission' },
        { label: 'Boolean' },
        { label: 'Date' },
        { label: 'Date/Time' },
        { label: 'Number' },
        { label: 'String' },
        { label: 'Time' }
    ]
};
